import React from 'react';
import Appbar from 'components/appbar/Appbar';
import SupplierListTable from './list/table/SupplierListTable';
import SupplierListModule from './list/module/SupplierListModule';
import SupplierAction from './SupplierAction';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import PaginationProvider from 'hooks/pagination';
import Pagination from 'components/pagination/Pagination';
import SupplierFilterBox from './SupplierFilterBox';
import { useFetchSuppliers } from './hooks/useFetchSuppliers';
import { useDisplayMode } from 'hooks/useDisplayMode';
import NoData from 'components/no-data/NoData';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';

const Supplier: React.FC = () => {
  const {
    suppliers,
    filter,
    loading,
    orderedIndex,
    handleSearch,
    handleSort,
    handleChange,
    setPage,
    setRows,
    page,
    rows,
    total,
  } = useFetchSuppliers();
  const [displayMode] = useDisplayMode();

  return (
    <>
      <Appbar title="Fornecedores" ActionsComponent={<SupplierAction />} />
      <PageHeaderActions
        title="Fornecedores"
        description="Gestão de fornecedores da clínica"
        ActionComponent={<NewRecordButton label="Novo fornecedor" to="/suppliers/new" />}
      />

      <SupplierFilterBox loading={loading} handleChange={handleChange} filter={filter} handleSearch={handleSearch} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : suppliers.length === 0 ? (
          <NoData message="Nenhum fornecedor encontrado" />
        ) : (
          <>
            {displayMode === 'list' ? (
              <SupplierListTable suppliers={suppliers} />
            ) : (
              <SupplierListModule suppliers={suppliers} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Supplier;
